// extracted by mini-css-extract-plugin
export default {"ratingWrapper":"StoreRating_ratingWrapper__UHnLW","stars":"StoreRating_stars__hizjq","extraInfo":"StoreRating_extraInfo__gimZL"};